import "core-js/modules/es.array.push.js";
import { getCache, setCache, removeCache } from '@/utils/session';
import { userLogin, getCodeTest, getInfo, getPermissions, uploadTracback, getCountryAndCurrencyInfo } from '@/api/user';
import { resetRouter, addedRouter } from '@/router';
import { randomLetterNumber, randomNumber } from '@/utils/public';
import * as rrweb from 'rrweb';
import moment from 'moment';
const state = {
  accountInfo: null,
  token: getCache('TOKEN') || '',
  permissions: getCache('PERMISSIONS') || [],
  recordInstance: null,
  traceBackEvents: [],
  pauseInstance: null,
  complexityPopup: sessionStorage.getItem('complexityPopup') ? sessionStorage.getItem('complexityPopup') : 'false',
  //密码复杂性弹框状态 true 弹框 false 不弹框
  resetPasswordModelVisible: false //是否重置密码
};
const mutations = {
  SET_RECORD_INSTANSCE(state, value) {
    state.recordInstance = value;
  },
  SET_PAUSE_INSTANSCE(state, value) {
    state.pauseInstance = value;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USERINFO(state, userInfo) {
    state.accountInfo = userInfo;
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  SET_TRACEBACK_EVENTS(state, event) {
    state.traceBackEvents.push(event);
  },
  CLEAR_TRACEBACK_EVENTS(state) {
    state.traceBackEvents = [];
  },
  SET_COMPLEXITYPOPUP(state, value) {
    state.complexityPopup = value;
    sessionStorage.setItem('complexityPopup', value);
  },
  SET_RESETPASSWORDMODELVISIBLE(state, value) {
    state.resetPasswordModelVisible = value;
  }
};
const actions = {
  login({
    commit
  }, userInfo) {
    return new Promise((resolve, reject) => {
      userLogin(userInfo).then(res => {
        console.log(res, 888);
        // logOffStatus:用户状态 true 注销 false 正常
        if (res.data && !res.data.multipleAccounts && !res.data.logOffStatus) {
          commit('SET_TOKEN', res.data.access_token);
          setCache('TOKEN', res.data.access_token);
          getCountryAndCurrencyInfo({}).then(res => {
            sessionStorage.setItem('countryAndCurrencyInfo', JSON.stringify(res));
          });
          // 存储密码复杂性弹框状态
          let complexityPopup = String(res.data.complexityPopup);
          commit('SET_COMPLEXITYPOPUP', complexityPopup);
        }
        sessionStorage.setItem('loginTime', new Date().getTime());
        sessionStorage.setItem('loginRandomId', `ID${randomNumber(3)}${sessionStorage.getItem('loginTime')}${randomLetterNumber(4)}`);
        sessionStorage.removeItem('temporaryToken');
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  codeTest({
    commit
  }, userInfo) {
    return new Promise((resolve, reject) => {
      getCodeTest(userInfo).then(res => {
        const {
          data
        } = res;
        if (data) {
          commit('SET_TOKEN', data.token);
          setCache('TOKEN', data.token);
        }
        resolve();
      }).catch(err => {
        reject(err);
      });
    });
  },
  logout({
    commit,
    state,
    rootState
  }) {
    commit('CLEAR_TRACEBACK_EVENTS');
    if (typeof state.recordInstance === 'function') {
      state.recordInstance();
    }
    if (state.pauseInstance) {
      clearTimeout(state.pauseInstance);
    }
    if (rootState.message.timerInstance) {
      //清除获取消息推送的定时器
      clearInterval(rootState.message.timerInstance);
    }
    commit('message/CLEAR_POP_MESSAGE_LIST', '', {
      root: true
    });
    sessionStorage.removeItem('popMessageList');
    commit('SET_TOKEN', '');
    commit('SET_USERINFO', '');
    removeCache('TOKEN');
    resetRouter();
    sessionStorage.removeItem('localeResource');
    sessionStorage.removeItem('complexityPopup');
    // resolve();
    // return new Promise((resolve, reject) => {
    //   logout()
    //     .then(() => {
    //       commit('SET_TOKEN', '');
    //       commit('SET_USERINFO', '');
    //       removeCache('TOKEN');
    //       resetRouter();
    //       resolve();
    //     })
    //     .catch(err => {
    //       reject(err);
    //     });
    // });
  },
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getInfo({}).then(res => {
        console.log(res, '用户信息accountInfo');
        if (res) {
          commit('SET_USERINFO', res);
          addedRouter();
        }
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
  updateInfo({
    commit
  }, userInfo) {
    return new Promise((resolve, reject) => {
      console.log(userInfo, 66666);
      commit('SET_USERINFO', userInfo);
      resolve();
    });
  },
  getPermissions({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getPermissions({}).then(res => {
        commit('SET_PERMISSIONS', res);
        setCache('PERMISSIONS', res);
        resolve(res);
      });
    });
  },
  setToken({
    commit
  }, token) {
    commit('SET_TOKEN', token);
    setCache('TOKEN', token);
  },
  reUploadTrackback({
    state,
    commit,
    dispatch
  }) {
    if (typeof state.recordInstance === 'function') {
      state.recordInstance();
    }
    commit('CLEAR_TRACEBACK_EVENTS');
    sessionStorage.setItem('loginRandomId', `ID${randomNumber(3)}${sessionStorage.getItem('loginTime')}${randomLetterNumber(4)}`);
    dispatch('setUploadTrackback');
  },
  setUploadTrackback({
    state,
    commit,
    dispatch
  }) {
    commit('CLEAR_TRACEBACK_EVENTS');
    let stopFun;
    let countNum = 0; //如果只有全量快照没有操作的时候不传
    const startRecord = () => {
      stopFun = rrweb.record({
        emit(event) {
          commit('SET_TRACEBACK_EVENTS', event);
          countNum++;
        }
      });
    };
    startRecord();
    commit('SET_RECORD_INSTANSCE', stopFun);
    let Timer = setInterval(async () => {
      let loginTime = sessionStorage.getItem('loginTime');
      let loginId = sessionStorage.getItem('loginRandomId');
      const userInfo = state.accountInfo;
      if (state.traceBackEvents.length && userInfo && countNum > 2) {
        let params = {
          loginId,
          source_channel: userInfo.customerId === 0 ? 1 : 2,
          type: 1,
          startAt: moment(Number(loginTime)).format('YYYY-MM-DD HH:mm:ss'),
          source: JSON.stringify(state.traceBackEvents),
          userId: userInfo.id,
          customerId: userInfo.customerId
        };
        uploadTracback(params);
        commit('CLEAR_TRACEBACK_EVENTS');
      } else {
        if (!userInfo) {
          clearInterval(Timer);
          if (typeof state.recordInstance === 'function') {
            state.recordInstance();
          }
          commit('CLEAR_TRACEBACK_EVENTS');
        }
      }
    }, 5 * 1000);
    let outTimer = setTimeout(() => {
      clearInterval(Timer);
      dispatch('reUploadTrackback');
    }, 30 * 60 * 1000);
    commit('SET_PAUSE_INSTANSCE', outTimer);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};